import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilLimitedActionTime } from "../../utils/utilLimitedActionTime";
import { IconWithText } from "../generic/icon-with-text/IconWithText";
import { getResourceIcon } from "../generic/icon/getResourceIcon";
import { TextLoca } from "../generic/text/TextLoca";
import { DoghouseTreatCountdown } from "./DoghouseTreatCountdown";
export var DoghouseTreatInfo = function (_a) {
    var freeTreatResource = _a.freeTreatResource, limitedActionInfo = _a.limitedActionInfo;
    var secondsUntilFreeTreat = utilLimitedActionTime.getLimitedActionResetRemainingTime(limitedActionInfo);
    var isFreeDogTreatAvailable = secondsUntilFreeTreat <= 0;
    var icon = getResourceIcon(freeTreatResource);
    if (isFreeDogTreatAvailable) {
        return (React.createElement("div", { className: "flex flex--guts resource-with-button" },
            React.createElement(IconWithText, { icon: icon, styleId: "hud-icon-with-text--icon " + IdStyles.IconLarge, className: "hud-icon-with-text", backgroundClassName: IdStyles.HudStat, backgroundSize: "medium", tooltipLoca: IdLoca.dog_treat_plural },
                React.createElement(TextLoca, { id: IdLoca.free, className: IdStyles.TextPositive }))));
    }
    return (React.createElement(DoghouseTreatCountdown, { limitedActionInfo: limitedActionInfo, availableFreeTreat: freeTreatResource.amount, freeTreatIcon: icon, secondsUntilNextTreat: secondsUntilFreeTreat }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/DoghouseTreatInfo.tsx
// module id = 2630
// module chunks = 3